import {fromJS, List, Map} from "immutable";

export function getAllWarehouses() {
  return fromJS([
    // {id: "us-california-01", label: "Carson, California (Jerich: us-california-01)", courier: true},
    // {id: "us-california-02", label: "Fontana, California (Ware2Go: us-california-02)", courier: true},
    // {id: "us-illinois-01", label: "Bedford Park, Illinois (Jerich: us-illinois-01)", courier: true},
    // {id: "at-gleisdorf-01", label: "Gleisdorf, Austria (Jerich: at-gleisdorf-01)", courier: true},
    // {id: "de-hamburg-01", label: "Hamburg, Germany (Jerich: de-hamburg-01)", courier: false},
    {id: "us-california-03", label: "Ontario, California (Ware2Go: us-california-03)", courier: true},
    {id: "us-newjersey-01", label: "Dayton, New Jersey (Jerich: us-newjersey-01)", courier: true},
    // {id: "us-pennsylvania-01", label: "Philadelphia, Pennsylvania (closed)", courier: true},
    {id: "us-pennsylvania-02", label: "Fairless Hills, Pennsylvania (Ware2Go: us-pennsylvania-02)", courier: true},
    // {id: "us-tennessee-01", label: "Ooltewah, Tennessee TN (closed)", courier: true},
    {id: "us-tennessee-02", label: "Ooltewah, Tennessee TN (Ware2Go: us-tennessee-02)", courier: true},

    {id: "at-factory-01", label: "Obertraun, Austria (Hallstein: at-factory-01)", shortLabel: "Obertraun Warehouse", courier: true},
    {id: "at-vienna-01", label: "Vienna, Austria (Byrd: at-vienna-01)", courier: true},
    {id: "at-enns-01", label: "Enns, Austria (Kühne + Nagel)", courier: false},

    {id: "gb-skelmersdale-01", label: "Skelmersdale, UK (Jerich: gb-skelmersdale-01)", courier: true},

    {id: "de-wesel-01", label: "Wesel, Germany (Jerich: de-wesel-01)", courier: false},

    {id: "ca-mississauga-01", label: "Mississauga, Canada (UL: ca-mississauga-01)", courier: true},

    {id: "ch-dintikon-01", label: "Dintikon, Switzerland (Swisspost: ch-dintikon-01)", courier: true},
    {id: "ch-planzer-01", label: "Kallnach, Switzerland (Planzer: ch-planzer-01)", courier: true},

    {id: "sg-singapore-01", label: "Singapore (Hallstein: sg-singapore-01)", shortLabel: "Singapore Warehouse", courier: true},
  ])
}

export function filterCourier(warehouses = List()) {
  return warehouses.filter((warehouse) => warehouse.get("courier") === true);
}

export function addAllWarehousesOption(warehouses = List(), label="All Warehouses") {
  return warehouses.unshift(Map({id: "", label: label}));
}